// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1761 ? "d0deef33" : chunkId) + "." + {"1761":"4676d619ca1e67eb","1966":"423548193db16a68","3899":"10522412c7bd8942","6169":"8f15ff3b70d5f760"}[chunkId] + ".js";
};